import { Card, Col, Row, Slider, Typography } from "antd";
import { Bar } from "react-chartjs-2";
import { useMemo, useState } from "react";

const { Text } = Typography;
const options = {
  responsive: true,
  plugins: {
    legend: {
      position: "top",
    },
    title: {
      display: false,
    },
  },
  scales: {
    x: {
      title: {
        display: true,
        text: "Zonas",
      },
      grid: {
        display: false,
      },
    },
    y: {
      title: {
        display: true,
        text: "Tempo de Permanência (min)",
      },
    },
  },
};

export default function BarChartWrapper({ data, maxZones, isLoading }) {
  const [selectedNumberZones, setSelectedNumberZones] = useState(null);

  const formattedData = useMemo(() => {
    if (!selectedNumberZones) {
      return data;
    }

    if (!data) {
      return { labels: [], datasets: [] };
    }

    const { labels, datasets } = data;

    const dataToFormat = datasets[0].data;
    const filteredByZones = labels
      .slice(0, selectedNumberZones)
      .map((label, index) => ({
        label: label,
        data: dataToFormat[index],
      }));

    filteredByZones.sort((a, b) => b.data - a.data);

    const filteredLabels = filteredByZones.map((item) => item.label);
    const filteredDataFinal = filteredByZones.map((item) => item.data);

    return {
      labels: filteredLabels,
      datasets: [
        {
          ...datasets[0],
          data: filteredDataFinal,
        },
      ],
    };
  }, [data, selectedNumberZones]);

  return (
    <Card
      title="Tempo de Permanência por Zona"
      align="center"
      style={{
        width: "85%",
      }}
      styles={{
        header: {
          backgroundColor: "#d0d6e2",
        },
      }}
      loading={isLoading}>
      <Row gutter={16}>
        <Col span={12} align="right">
          <Text strong style={{ marginRight: 10 }}>
            Escolha o número de zonas a serem mostradas:
          </Text>
        </Col>
        <Col span={12} align="left">
          <Slider
            defaultValue={maxZones}
            min={1}
            max={maxZones}
            marks={
              maxZones
                ? {
                    1: "1",
                    [Math.floor(maxZones / 2) || 1]:
                      `${Math.floor(maxZones / 2) || 1}`,
                    [maxZones]: `${maxZones}`,
                  }
                : { 1: "1" }
            }
            style={{ width: "200px" }}
            onChangeComplete={(value) => setSelectedNumberZones(value)}
          />
        </Col>
      </Row>
      {formattedData && <Bar data={formattedData} options={options} />}
    </Card>
  );
}
